import { render, staticRenderFns } from "./ErrMsg.vue?vue&type=template&id=b01b462c&scoped=true&"
import script from "./ErrMsg.vue?vue&type=script&lang=js&"
export * from "./ErrMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01b462c",
  null
  
)

export default component.exports